import { Component, OnInit, Input, ViewChild, EventEmitter, Output, ElementRef, AfterViewInit } from '@angular/core';
import { DetailService } from '../services/detail.service';
import { Detail, DetailPropertyGroup, FormProperties, Options, Action, OptionsGroup, TransportValueSelection } from '../objects/DetailObject';
import { NgForm } from '@angular/forms';
import { ScrollService } from '../services/scroll.service';
import { ConfirmationService } from '../services/confirmation.service';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap';
import { ToasterMessageService } from '../services/toaster-message.service';
import { DetailPopupComponent } from '../detail-popup/detail-popup.component';
import { Router } from '@angular/router';
import { ModalControlService } from '../services/modal-control.service';
import { MessagePopupService } from '../services/message-popup.service';
import { WorkspaceService } from '../services/workspace.service';
import { MatRadioButton, MatCheckbox } from '@angular/material';
import { ThemeSettingService } from '../services/theme-setting.service';
import { ThemeSetting } from '../objects/ThemeObject';
import { Globals } from '../objects/Globals';
import { HeaderService } from '../services/header.service';
import { LoginService } from '../services/login.service';
import { AttachmentService } from '../services/attachment.service';

@Component({
  selector: 'app-detail-form',
  templateUrl: './detail-form.component.html',
  styleUrls: ['./detail-form.component.css']
})
export class DetailFormComponent implements OnInit, AfterViewInit {

  private componentId: string;
  private modalRef: BsModalRef;
  
  animate:boolean = false;
  submitted: boolean = false;
  detailForm: Detail;
  actions: Action[] = [];
  invalidProperties = [];
  groups: DetailPropertyGroup[];
  formProperties: FormProperties[];
  isBusy:boolean = false;
  loaderConfig: any;
  currentScore: string;
  maxScore: number;
  updatedDate: any;
  focusProp: string;

  @ViewChild('detailForm') subDetailForm: NgForm;

  @ViewChild('detailContainer') public detailContainer;
  @ViewChild('textbox') textbox:ElementRef;
  @ViewChild('textarea') textarea:ElementRef;
  @ViewChild('matRadio') matRadio: MatRadioButton;
  @ViewChild('matCheckbox') matCheckbox: MatCheckbox;
  
  @Output() hidePopup = new EventEmitter<boolean>();
  @Output() subForm = new EventEmitter<any>();
  @Input() isPopup: boolean;
  @Input() autoRefresh: boolean;

  @Input() set setSubForm(obj: any){
    this.isBusy = true;
    if (!this.autoRefresh) this.isBusy = true;
    this.detailService.newFormFromDetail(obj.DetailId, obj.PropertyGroupId).subscribe(id => {
      if (id){
        this.componentId = id;
        this.getFormDetailCard();
      }
      else{
        this.isBusy = false;
      }
    }, error => {
      this.isBusy = false;
    });
  }

  @Input() set setComponentId(id: string){
    this.componentId = id;
    this.isBusy = true;
    this.getFormDetailCard();
  }

  @Input() set triggerFocus(trigger: boolean){
    if (this.detailForm){
      this.submitted = true;
      this.saveInvalidProperties();
    }
  }

  @Input() set actionOnDetail(action: Action){
    if (action){
      this.formAction(action, this.subDetailForm, false)
    }
  }

  @Output() detailActions = new EventEmitter<any>();

  saveInvalidProperties(){
    this.invalidProperties = [];
    var focus: boolean = false;

    this.groups.forEach(group => {

      this.formProperties.filter(x => x.PropertyGroupId == group.GroupId).forEach(property => {
        if (this.subDetailForm.control.get(property.PropertyName)){
          if (this.subDetailForm.control.get(property.PropertyName).invalid){
            this.invalidProperties.push(property.PropertyName);
            if (!focus){
              this.handlePropertyFocus(property.PropertyName);
              focus = true;
            }
          }
          else{
            if (property.PropertyOptions){
              var option = property.PropertyOptions.find(x => x.OptionValue == property.PropertyValue);
              if (option){
                if (option.OptionRequiresRemarks && option.OptionRemarksMandatory){
                  if (!property.PropertyRemarks){
                    if (!focus){
                      this.handlePropertyFocus(property.PropertyName, true);
                      focus = true;
                    }
                  }
                }
              }
            }
          }
        }
      });
    });
  }

  constructor(private router: Router,
    private modalControlService: ModalControlService,
    private detailService: DetailService, 
    private scrollService: ScrollService, 
    private confirmationService: ConfirmationService,
    private modalService: BsModalService,
    private toasterMessageService: ToasterMessageService,
    private messagePopupService: MessagePopupService,
    private workspaceService: WorkspaceService,
    private themeSettingService: ThemeSettingService,
    private globals: Globals,
    private headerService: HeaderService,
    private loginService: LoginService,
    private attachmentService: AttachmentService) {
     }

  ngOnInit() {
    var themes:ThemeSetting = this.themeSettingService.getTheme();
    this.loaderConfig = themes;
  }

  ngAfterViewInit(){
    if (this.subDetailForm){
        this.subDetailForm.statusChanges.subscribe(result => {
          var obj = {form: this.subDetailForm, actions: this.actions}
          this.subForm.emit(obj);
        });
    }
  }

  getFormDetailCard(){
    this.detailService.getFormDetailCard(this.componentId).subscribe(result => {
      var tempForm:Detail = JSON.parse(result);
      // console.log(JSON.parse(result));
      this.sortDetailActions(tempForm);
      this.sortFormProperties(tempForm);
      this.sortFormPropertyOptions(tempForm);
      this.sortFormPropertyOptionsGroups(tempForm);
      this.sortPropertyGroups(tempForm);
      this.constructMatrixRows(tempForm);
      this.detailActions.emit(tempForm.Actions);
      this.detailForm = tempForm;
      this.currentScore = this.detailForm.DocTitle;
      this.maxScore = this.detailForm.FormMaxScore;
      this.updatedDate = this.detailForm.DocSubtitle;
      this.groups = tempForm.Groups;
      this.actions = this.detailForm.Actions;
      this.formProperties = tempForm.FormProperties;
      this.isBusy = false;
    })
  }

  constructMatrixRows(tempForm: Detail){
    tempForm.FormProperties.forEach(property => {
      if (property.PropertyType == "MATRIX"){
        var count = property.PropertyOptions.map(x => x.OptionOrder).filter((value, index, self) => self.indexOf(value) === index).length;
        property.PropertyOptionRows = [];
        for (var k = 1; k < count + 1; k++){
          var array = property.PropertyOptions.filter(x => x.OptionOrder == k);
          var newArray = [];
          property.PropertyOptionGroups.forEach(group => {
            var option = array.find(x => x.OptionGroup == group.GroupId);
            if(option){
              newArray.push(option);
            }
          });
          property.PropertyOptionRows.push(newArray);
        }

        property.TransportValueSelection = [];
        var object;
        if (property.PropertyValue){
          object = JSON.parse(property.PropertyValue);
        }
        property.PropertyOptionRows.forEach(row => {
          var groupId;
          if (object){
            groupId = object[row[0].OptionValue];
            if (groupId){
              if (row.find(x => x.OptionGroup == groupId)){
                row.find(x => x.OptionGroup == groupId).OptionIsSelected = true;
              }
            }
          }
          else{
            groupId = row[0].OptionValue;
          }

          var tvs: TransportValueSelection = {
            OptionValue: row[0].OptionValue,
            GroupId: groupId
          }

          property.TransportValueSelection.push(tvs);

        }); 
      }
    });
    
  }

  sortDetailActions(tempForm: Detail){
    tempForm.Actions = tempForm.Actions.sort((a:Action,b:Action) => { 
      if(a.ActionOrder > b.ActionOrder){
        return 1;
      }else if(a.ActionOrder < b.ActionOrder){
        return -1;
      }else{
        return 0;
      }
     });
  }

  sortPropertyGroups(tempForm: Detail){
    tempForm.Groups = tempForm.Groups.sort((a:DetailPropertyGroup,b:DetailPropertyGroup) => { 
      if(a.GroupOrder > b.GroupOrder){
        return 1;
      }else if(a.GroupOrder < b.GroupOrder){
        return -1;
      }else{
        return 0;
      }
     });
  } 

  sortFormProperties(tempForm: Detail){
    tempForm.FormProperties = tempForm.FormProperties.sort((a:FormProperties,b:FormProperties) => { 
      if(a.PropertyOrder > b.PropertyOrder){
        return 1;
      }else if(a.PropertyOrder < b.PropertyOrder){
        return -1;
      }else{
        return 0;
      }
     });
  } 

  sortFormPropertyOptions(tempForm: Detail){
    tempForm.FormProperties.forEach(property => {
      property.PropertyFormattedName = property.PropertyName.replace(/\s/g, "");
      if (property.PropertyOptions){
        property.PropertyOptions = property.PropertyOptions.sort((a:Options,b:Options) => { 
          if(a.OptionOrder > b.OptionOrder){
            return 1;
          }else if(a.OptionOrder < b.OptionOrder){
            return -1;
          }else{
            return 0;
          }
         });
      }
    });
  } 

  sortFormPropertyOptionsGroups(tempForm: Detail){
    tempForm.FormProperties.forEach(property => {
      if (property.PropertyOptionGroups){
        property.PropertyOptionGroups = property.PropertyOptionGroups.sort((a:OptionsGroup,b:OptionsGroup) => { 
          if(a.GroupOrder > b.GroupOrder){
            return 1;
          }else if(a.GroupOrder < b.GroupOrder){
            return -1;
          }else{
            return 0;
          }
         });
      }
    });
  } 

  updatePropertyValue(property: FormProperties, value: any, index: number = 0){
    var newValue = value;
    if (property.PropertyType.toUpperCase() == 'MATRIX'){
      var propOption = property.PropertyOptions.find(x => x.OptionValue == value.source.value);

      var json = {};
      property.TransportValueSelection.forEach(selection => {
        if (selection.OptionValue == propOption.OptionValue){
          selection.GroupId = property.PropertyOptionGroups[index].GroupId; //this should be the new group Id
        }
        json[selection.OptionValue] = selection.GroupId;
      })

      newValue = json;
    }

    var index = this.invalidProperties.indexOf(property.PropertyName);
    if (index > -1) this.invalidProperties.splice(index, 1);

    this.detailService.updateFormPropertyValue(this.componentId, property.PropertyName, newValue).subscribe(result => {
      //console.log(result);
    });
    
  }

  updatePropertyRemarks(property: FormProperties, value: string){
    this.detailService.updateFormPropertyRemarks(this.componentId, property.PropertyName, value).subscribe(result => {
      //console.log(result);
    });
  }

  updatePropertyBaseRemarks(property: FormProperties, value: string){
    this.detailService.updateFormBaseRemarks(this.componentId, property.PropertyName, value).subscribe(result => {
      console.log(result);
    })
  }

  formAction(action:any, form: NgForm, scrollToTop:boolean){
    this.animate = false;
    if (action.TriggersValidation){
      if (form.valid){
          // if (scrollToTop){
          //   this.scrollService.triggerScrollTo(this.detailContainer);
          // }
          this.handlePrompt(action);
      }
      else{
        this.submitted = true;
        for (var i in this.detailForm.FormProperties){
          if (form.control.get(this.detailForm.FormProperties[i].PropertyName)){
            if (form.control.get(this.detailForm.FormProperties[i].PropertyName).invalid){
              this.handlePropertyFocus(i);
              break;
            }
          }
        }
      }
    }
    else{
      // if (scrollToTop){
      //   this.scrollService.triggerScrollTo(this.detailContainer);
      // }
      this.handlePrompt(action);
    }
  }

  handlePropertyFocus(name:string, isRemarks: boolean = false){
    this.submitted = true;
    this.focusProp = this.formProperties.find(x => x.PropertyName == name).PropertyName;
    if (isRemarks){
      var el = document.querySelectorAll('.remarks_' + this.focusProp.replace(/\s/g, ''))[0];
      if (el){
        this.scrollService.triggerScrollTo(el);
      }
    }
    else{
      var element = document.querySelector('#field_' + this.focusProp.replace(/\s/g, ''));
      if (element){
        this.scrollService.triggerScrollTo(element);
      }
    }
    
    // switch (this.detailForm.FormProperties[index].PropertyType.toUpperCase()){
    //   case "TEXT":
    //     this.textarea.nativeElement.focus();
    //     break;
    //   case "SINGLESELECT":
    //     this.matRadio.focus();
    //     break;
    //   case "MULTISELECT":
    //       this.matCheckbox.focus();
    //     break;
    //   case "MATRIX":
    //     break;
    // }
  }

  handlePrompt(action: Action){
    if (action.TriggersPrompt){
      switch(action.PromptType){
        case "Yes|No":
        this.confirmationService.confirm(
          "Confirmation",
          action.PromptMessage,
          ["CANCEL", "OK"])
          .subscribe((respond) => {
            if (respond.answer == "OK"){
              this.detailAction(action);
            }
          });
        break;
        case "TypeToConfirm":
        this.confirmationService.confirm(
          action.PromptMessage.split('|')[0],
          "",
          ["CANCEL", "OK"], true, action.PromptMessage.split('|')[1], false, action.PromptMessage.split('|')[2])
          .subscribe((respond) => {
            if (respond.answer == "OK"){
              this.detailAction(action);
            }
          });
          break;
        case "Preview":
        this.isBusy = true;
        this.detailService.checkActionPrompt(this.componentId, action.ActionCommand).subscribe(result => {
          if (result){
            this.isBusy = false;
            this.handleWorkflowReturn(result);
          }
          else{
            this.detailService.getPreview(this.componentId, action.ActionCommand).subscribe(previewId=>{
              this.isBusy = false;
              this.openPopup(previewId, action.PromptMessage.split('|')[0]);
            });
          }
        });
        break;
      }
    }
    else{
      this.detailAction(action);
    }
  }

  detailAction(action:any) {
    this.animate = false;
    this.detailService.actionFormDetailCard(this.componentId, action.ActionCommand).subscribe(result=> {
      this.animate = true;
      this.handleWorkflowReturn(result);

    });
  }

  openPopup(event, title: string) {
    const config: ModalOptions = {
      keyboard: false,
      ignoreBackdropClick: true,
      class: 'modal-dialog-centered modal-detail',
      initialState: {
        componentId: event,
        title: title
      }
    };

    if (this.modalService.getModalsCount() > 0){
      document.querySelectorAll('.modal.fade').item(this.modalService.getModalsCount() - 1).classList.remove('show');
    }

    this.modalService.onHide.subscribe((reason: string) => {
      if (this.modalService.getModalsCount() > 0){
        document.querySelectorAll('.modal.fade').item(this.modalService.getModalsCount() - 1).classList.add('show');
      }
    })

    this.modalRef = this.modalService.show(DetailPopupComponent, config);
  }

  handleWorkflowReturn(result: any): any {
    var command = JSON.parse(result);
      switch(command.ReturnType){
        case 0: // navigate
          if(command.Arguments){
            var path = [];
            command.Arguments.forEach(element => {
              path.push(element);
            });
            this.router.navigate(path);
          }
          break;
        case 1: //message
          this.toasterMessageService.popToast(command.Arguments[0], command.Arguments[1], command.SubType);
          break;
        case 2: //reload, does nothing, depends on refreshtype
          break;
        case 3: //open detail
          this.openPopup(command.Arguments[0], command.Arguments[1]);
          break;
        case 4: //message
          var list = ["parent", "all"];
          if (list.filter(x => x == command.RefreshType).length == 0){
            // this.hidePopup.emit(true);
            if (this.modalService.getModalsCount() > 0){
              this.modalService.hide(this.modalService.getModalsCount());
              if (this.modalService.getModalsCount() == 0) { document.body.classList.remove("modal-open")}
            }
          }
          this.toasterMessageService.popToast(command.Arguments[0], command.Arguments[1], command.SubType);
          if (command.Arguments[2]){
            this.openPopup(command.Arguments[2], "");
          }
          break;
        case 5: //summary popup
          this.modalControlService.launchModal(command.Arguments[0], command.Arguments[1], "summary", "modal-summary");
          break;
        case 6:
          //comparison
          this.modalControlService.launchModal(command.Arguments[0], command.Arguments[1], "compare");
          break;
        case 7: //download file
          this.attachmentService.downloadFile(command.Arguments[0]).subscribe(data=>{
            this.downloadFile(data, command.Arguments[1]);
          });
          break;
        case 8:
          if (this.globals.Session){
            if(command.Arguments){
              this.handleNavigateAndMessage(command, true);
            }
          }
          else{
            this.messagePopupService.popMessage(command.Arguments[0], command.Arguments[1], ["OK"]).subscribe((respond) => {
              if (respond.answer == "OK"){
                this.handleNavigateAndMessage(command);
              }
            });
          }
          break;
        case 9: //chart
          break;
        case 10:
          this.isBusy = true;
          this.loginService.goHome().subscribe(result=>{
            this.isBusy = false;
            this.globals.Session.HomeUrl = JSON.parse(result);
            this.router.navigate(this.globals.Session.HomeUrl);
          });
          break;
        case 11:
          this.isBusy = true;
          this.modalControlService.launchModal(command.Arguments[0], command.Arguments[1], "form", "modal-form");
          this.isBusy = false;
          break;
      }

      switch(command.RefreshType){
        case "self": this.getFormDetailCard(); break;
        case "parent": 
          this.isBusy = true;
          this.getFormDetailCard();
          this.getEPICParent(false, command.ReturnType);
          break;
        case "all":
          this.getFormDetailCard();
          this.getEPICParent(true, command.ReturnType);
        break;
      }
  }

  getEPICParent(findAllParent:boolean, returnType:number){
    if (findAllParent){
      this.workspaceService.getAllParentsEPICId(this.componentId).subscribe(result => {
        this.handlePopup(returnType);
        if (result){
          var array = JSON.parse(result);
          array.forEach(id => {
            this.workspaceService.setParentId(id);
          });
        }
      }, error => {
        this.handlePopup(returnType);
      })
    }
    else{
      this.workspaceService.getParentEPICId(this.componentId).subscribe(result => {
        this.workspaceService.setParentId(result);
        this.handlePopup(returnType);
      }, error => {
        this.handlePopup(returnType);
      })
    }
  }

  handlePopup(returnType){
    if (returnType == 4){
      this.hidePopup.emit(true);
    }
  }

  handleNavigateAndMessage(command:any, hasSession:boolean = false){
    var path = [];
    var newArgs = command.Arguments.splice(2);
    newArgs.forEach(element => {
      path.push(element);
    });
    
    if (hasSession){
      // close all popups
      for (let i = 1; i <= this.modalService.getModalsCount(); i++) {
        this.modalService.hide(i);
      }
      document.body.classList.remove("modal-open");

      this.router.navigate(path);
      this.headerService.setSelectedMenu('clearSelected');
      this.toasterMessageService.popToast(command.Arguments[0], command.Arguments[1], command.SubType);
    }
  }

  downloadFile(blob: any, fileName:string): void {
    const objectUrl: string = URL.createObjectURL(blob);
    const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;

    a.href = objectUrl;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();        

    document.body.removeChild(a);
    URL.revokeObjectURL(objectUrl);
  }
}
